/* ==========================================================================
   Arts & Crafts Shop — EU / UK store notice
   Tells shoppers in the UK and Europe that their order ships from the
   Townsend store (artsandcrafts.tmstor.es) instead of Canada.

   Two surfaces:
     1. A modal, shown once per shopper (site-wide).
     2. An inline notice on product pages, next to the buy button.

   WHAT YOU EDIT, AND WHERE
     Countries ............. Theme customizer  ("EU / UK store notice" section)
     Copy .................. Theme customizer
     Product list .......... townsend-stock.json in Assets, generated from
                             Townsend's CSV by tools/build-townsend-map.py.
                             You should not need to edit this file for that.

   TESTING WITHOUT A VPN
     Add ?ac_geo=GB to any URL to pretend you are in that country.
     Add ?ac_geo=reset to clear it and go back to real detection.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------ *
   * 1. TOWNSEND PRODUCT MAP  —  edit this as Townsend adds titles
   * ------------------------------------------------------------------ *
   *
   * Townsend does not carry the whole catalogue, so we match in three
   * steps and use the first one that hits:
   *
   *   byHandle  the exact product. Key is the Shopify handle, the part of
   *             the URL after /products/. Most precise, use where you can.
   *
   *   byArtist  everything by one artist. Key is the artist name exactly
   *             as it appears in the product's "ARTISTS: ..." tag.
   *
   *   (nothing) no match. The shopper still sees the modal, but the
   *             product page notice stays hidden, because sending someone
   *             to a store that does not stock the record is worse than
   *             saying nothing.
   *
   * ---------------------------------------------------------------------
   * ONE PRODUCT HERE, SEVERAL PRODUCTS THERE
   *
   * On this store a release is one product with LP / CD / Cassette
   * variants. On Townsend each format is its own product, so a single
   * link would send a CD buyer to the LP page. Use `variants` for those:
   *
   *   'artist-album': {
   *     variants: {
   *       'LP':       'https://artsandcrafts.tmstor.es/product/1111',
   *       'CD':       'https://artsandcrafts.tmstor.es/product/2222',
   *       'Cassette': false        // they do not carry this format
   *     }
   *   }
   *
   * Variant keys can be the variant title as it appears on this store
   * ("LP", or "LP / Black" when there are two options), any single option
   * value ("LP" also matches the variant "LP / Black"), or the numeric
   * Shopify variant ID if a title is ever ambiguous. Matching ignores
   * case. The link updates as the shopper switches format.
   *
   * A variant that is not listed shows no notice, unless you add a
   * `url` alongside `variants` as a catch-all for the rest.
   *
   * Set `carries: false` to mark a whole product as not stocked in
   * Europe, which stops a broader byArtist rule from claiming it.
   */

  var TOWNSEND_MAP = {
    home: 'https://artsandcrafts.tmstor.es/',

    byHandle: {
      // Same product on both stores:
      // 'a-c-place-mat': 'https://artsandcrafts.tmstor.es/product/xxxxx',

      // Split by format on Townsend:
      // 'broken-social-scene-remember-the-humans': {
      //   variants: {
      //     'LP':       'https://artsandcrafts.tmstor.es/product/1111',
      //     'CD':       'https://artsandcrafts.tmstor.es/product/2222',
      //     'Cassette': false
      //   }
      // },

      // Deliberately not stocked in Europe:
      // 'a-c-summer-19-tee-tote': { carries: false },
    },

    byArtist: {
      // 'Broken Social Scene': 'https://artsandcrafts.tmstor.es/artist/broken-social-scene',
      // 'Andy Shauf':          'https://artsandcrafts.tmstor.es/artist/andy-shauf',
    }
  };

  /* ------------------------------------------------------------------ *
   * 2. Country groups — used by the customizer's group toggles
   * ------------------------------------------------------------------ */

  var GROUPS = {
    uk: ['GB'],
    eu27: ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE',
           'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT',
           'RO', 'SK', 'SI', 'ES', 'SE'],
    eea_ch: ['NO', 'IS', 'LI', 'CH']
  };

  var COUNTRY_NAMES = {
    GB: 'the UK', IE: 'Ireland', FR: 'France', DE: 'Germany', ES: 'Spain',
    IT: 'Italy', NL: 'the Netherlands', BE: 'Belgium', AT: 'Austria',
    PT: 'Portugal', SE: 'Sweden', DK: 'Denmark', FI: 'Finland', NO: 'Norway',
    PL: 'Poland', CZ: 'Czechia', GR: 'Greece', HU: 'Hungary', RO: 'Romania',
    CH: 'Switzerland', IS: 'Iceland', SK: 'Slovakia', SI: 'Slovenia',
    HR: 'Croatia', BG: 'Bulgaria', EE: 'Estonia', LV: 'Latvia',
    LT: 'Lithuania', LU: 'Luxembourg', MT: 'Malta', CY: 'Cyprus',
    LI: 'Liechtenstein'
  };

  /* ------------------------------------------------------------------ *
   * 3. Settings — Liquid fills window.ACEU_SETTINGS; these are fallbacks
   * ------------------------------------------------------------------ */

  var S = Object.assign({
    enabled: true,
    countries: [],
    groups: { uk: true, eu27: true, eea_ch: true },

    showModal: true,
    modalScope: 'home',        // 'home' = home page only, 'all' = every page
    showProductNotice: true,

    modalEyebrow: 'Shipping to {country}',
    modalHeading: 'There is a closer store',
    modalBody: 'Orders from this store ship from Canada, which means longer waits and customs charges on arrival.',
    modalPrimary: 'Shop the European store',
    modalSecondary: 'Stay on this store',
    modalFootnote: 'The European store carries a selection of our catalogue, not everything.',

    noticeHeading: 'Also available closer to you',
    noticeBody: 'This is stocked by our European store.',
    noticeBodyOther: 'The {format} is stocked by our European store.',
    noticeLink: 'View product',

    reshowAfterDays: 30,
    delayMs: 1200,
    townsendHome: ''
  }, window.ACEU_SETTINGS || {});

  if (S.townsendHome) TOWNSEND_MAP.home = S.townsendHome;
  if (window.ACEU_MAP_OVERRIDE) TOWNSEND_MAP = window.ACEU_MAP_OVERRIDE;

  /* ------------------------------------------------------------------ *
   * 3b. The product list, loaded from townsend-stock.json
   * ------------------------------------------------------------------ *
   * That file is generated from Townsend's stock CSV and uploaded to
   * Assets, so updating the product list never means editing this file.
   * Anything written into TOWNSEND_MAP above still applies, and the JSON
   * layers on top of it. Only fetched once we know the shopper is in a
   * country we care about, so it costs nothing for everyone else.
   */

  var mapPromise = null;

  function loadMap() {
    if (mapPromise) return mapPromise;
    if (!S.mapUrl) return (mapPromise = Promise.resolve());

    mapPromise = fetch(S.mapUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        // A home URL typed into the customizer beats the generated one.
        if (d.home && !S.townsendHome) TOWNSEND_MAP.home = d.home;
        Object.keys(d.products || {}).forEach(function (handle) {
          TOWNSEND_MAP.byHandle[handle] = d.products[handle];
        });
      })
      .catch(function () { /* leave the map as-is; nothing will show */ });

    return mapPromise;
  }

  var STORE_KEY = 'aceu_dismissed_v1';
  var GEO_KEY   = 'aceu_geo_v1';
  var PIN_KEY   = 'aceu_forced_v1';

  /* ------------------------------------------------------------------ *
   * 4. Which countries are in scope
   * ------------------------------------------------------------------ */

  function targetCountries() {
    var set = {};
    Object.keys(GROUPS).forEach(function (g) {
      if (S.groups && S.groups[g]) GROUPS[g].forEach(function (c) { set[c] = true; });
    });
    // The free-text list adds countries, and removes them when prefixed
    // with a minus, so "-IE" keeps Ireland on the Canadian store.
    (S.countries || []).forEach(function (raw) {
      var c = String(raw).trim().toUpperCase();
      if (!c) return;
      if (c.charAt(0) === '-') delete set[c.slice(1).trim()];
      else set[c] = true;
    });
    return set;
  }

  /* ------------------------------------------------------------------ *
   * 5. Where is the shopper
   * ------------------------------------------------------------------ */

  function readOverride() {
    var q = new URLSearchParams(window.location.search).get('ac_geo');
    if (q) {
      q = q.trim().toUpperCase();
      try {
        if (q === 'RESET' || q === 'OFF') {
          localStorage.removeItem(PIN_KEY);
          localStorage.removeItem(STORE_KEY);
          sessionStorage.removeItem(GEO_KEY);
          return null;
        }
        localStorage.setItem(PIN_KEY, q);
      } catch (e) {}
      return q;
    }
    try { return localStorage.getItem(PIN_KEY); } catch (e) { return null; }
  }

  // Rough fallback for when the Shopify lookup is unavailable, e.g. a
  // shopper behind an aggressive privacy extension. Timezones are not a
  // reliable read of residence, so this only ever feeds the modal.
  function countryFromTimezone() {
    var tz;
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return null; }
    var m = {
      'Europe/London': 'GB', 'Europe/Dublin': 'IE', 'Europe/Paris': 'FR',
      'Europe/Berlin': 'DE', 'Europe/Madrid': 'ES', 'Europe/Rome': 'IT',
      'Europe/Amsterdam': 'NL', 'Europe/Brussels': 'BE', 'Europe/Vienna': 'AT',
      'Europe/Lisbon': 'PT', 'Europe/Stockholm': 'SE', 'Europe/Copenhagen': 'DK',
      'Europe/Helsinki': 'FI', 'Europe/Oslo': 'NO', 'Europe/Warsaw': 'PL',
      'Europe/Prague': 'CZ', 'Europe/Athens': 'GR', 'Europe/Budapest': 'HU',
      'Europe/Bucharest': 'RO', 'Europe/Zurich': 'CH', 'Atlantic/Reykjavik': 'IS',
      'Europe/Bratislava': 'SK', 'Europe/Ljubljana': 'SI', 'Europe/Zagreb': 'HR',
      'Europe/Sofia': 'BG', 'Europe/Tallinn': 'EE', 'Europe/Riga': 'LV',
      'Europe/Vilnius': 'LT', 'Europe/Luxembourg': 'LU', 'Europe/Malta': 'MT',
      'Asia/Nicosia': 'CY', 'Europe/Vaduz': 'LI'
    };
    return m[tz] || null;
  }

  function detectCountry() {
    var forced = readOverride();
    if (forced) return Promise.resolve(forced);

    try {
      var cached = sessionStorage.getItem(GEO_KEY);
      if (cached) return Promise.resolve(cached);
    } catch (e) {}

    // Shopify's own recommendation endpoint. First party, no API key, and
    // it is the same IP lookup that powers the theme's country picker.
    return fetch('/browsing_context_suggestions.json?country[enabled]=true', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country &&
                d.detected_values.country.handle;
        if (!c) throw new Error('no country');
        try { sessionStorage.setItem(GEO_KEY, c); } catch (e) {}
        return c;
      })
      .catch(function () { return countryFromTimezone(); });
  }

  /* ------------------------------------------------------------------ *
   * 6. Does Townsend stock this product
   * ------------------------------------------------------------------ */

  // Which format is selected right now. The hidden id input is the one
  // thing every Shopify theme keeps current, with the URL as a backstop.
  function currentVariant(ctx) {
    if (!ctx || !ctx.variants || !ctx.variants.length) return null;

    var id = null;
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) id = String(input.value);
    if (!id) id = new URLSearchParams(window.location.search).get('variant');
    if (!id) id = ctx.selectedId != null ? String(ctx.selectedId) : null;

    for (var i = 0; i < ctx.variants.length; i++) {
      if (String(ctx.variants[i].id) === String(id)) return ctx.variants[i];
    }
    return ctx.variants[0];
  }

  // Look a variant up by ID, by full title ("LP / Black"), or by any one
  // of its option values ("LP"), whichever the map happens to use.
  function variantRule(entry, variant) {
    if (!entry || !entry.variants || !variant) return undefined;
    var table = entry.variants;

    if (variant.id != null && table[variant.id] !== undefined) return table[variant.id];

    var keys = Object.keys(table);
    var tries = [variant.title].concat(variant.options || []);

    for (var i = 0; i < tries.length; i++) {
      var want = String(tries[i] == null ? '' : tries[i]).trim().toLowerCase();
      if (!want) continue;
      for (var k = 0; k < keys.length; k++) {
        if (String(keys[k]).trim().toLowerCase() === want) return table[keys[k]];
      }
    }
    return undefined;
  }

  function unwrap(rule) {
    if (rule === false) return null;
    if (typeof rule === 'string') return rule;
    if (rule && typeof rule === 'object') {
      return rule.carries === false ? null : (rule.url || null);
    }
    return null;
  }

  function resolveProduct(ctx, variant) {
    if (!ctx || !ctx.handle) return null;
    if (variant === undefined) variant = currentVariant(ctx);

    var direct = TOWNSEND_MAP.byHandle && TOWNSEND_MAP.byHandle[ctx.handle];
    if (typeof direct === 'string') return direct;

    // An object entry is how you say "handle this one specially": split it
    // by format, or mark it as not stocked so byArtist cannot claim it.
    if (direct && typeof direct === 'object') {
      if (direct.carries === false) return null;

      var rule = variantRule(direct, variant);
      if (rule !== undefined) return unwrap(rule);

      // The product is split by format but this one is not listed, so we
      // only have somewhere to send them if a catch-all url was given.
      if (direct.variants) return direct.url || null;
      return unwrap(direct);
    }

    var artists = (ctx.tags || [])
      .filter(function (t) { return /^ARTISTS:/i.test(t); })
      .map(function (t) { return t.replace(/^ARTISTS:\s*/i, '').trim(); });

    for (var i = 0; i < artists.length; i++) {
      var hit = TOWNSEND_MAP.byArtist && TOWNSEND_MAP.byArtist[artists[i]];
      if (hit) return unwrap(hit);
    }
    return null;
  }

  /* ------------------------------------------------------------------ *
   * 7. Rendering
   * ------------------------------------------------------------------ */

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fill(tpl, country, format) {
    return esc(tpl)
      .replace(/\{country\}/g, esc(COUNTRY_NAMES[country] || 'your country'))
      .replace(/\{format\}/g, esc(format || ''));
  }

  // What should the notice point at? The format the shopper is looking at
  // wins. Failing that, any other format Townsend stocks, so a release they
  // carry on CD still surfaces to someone who landed on the LP. Shopify
  // preselects the first available variant, which is often not the one
  // Townsend has, and silence there reads as the feature being broken.
  function resolveForNotice(ctx) {
    if (!ctx) return null;
    var sel = currentVariant(ctx);

    var exact = resolveProduct(ctx, sel);
    if (exact) return { url: exact, otherFormat: null };

    var vs = ctx.variants || [];
    for (var i = 0; i < vs.length; i++) {
      if (sel && String(vs[i].id) === String(sel.id)) continue;
      var u = resolveProduct(ctx, vs[i]);
      if (u) return { url: u, otherFormat: vs[i].title };
    }
    return null;
  }

  // Liquid tells us the template outright. The path check is the fallback
  // for the local preview, where there is no Liquid to ask.
  function isHomePage() {
    if (S.template) return S.template === 'index';
    return window.location.pathname.replace(/\/+$/, '') === '';
  }

  function modalAllowedHere() {
    return S.modalScope === 'all' || isHomePage();
  }

  function dismissed() {
    try {
      var v = localStorage.getItem(STORE_KEY);
      if (!v) return false;
      var age = (Date.now() - parseInt(v, 10)) / 86400000;
      return age < (S.reshowAfterDays || 30);
    } catch (e) { return false; }
  }

  function remember() {
    try { localStorage.setItem(STORE_KEY, String(Date.now())); } catch (e) {}
  }

  var lastFocus = null;

  function buildModal(country, url) {
    var wrap = document.createElement('div');
    wrap.className = 'aceu-overlay';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-labelledby', 'aceu-title');

    wrap.innerHTML =
      '<div class="aceu-modal">' +
        '<div class="aceu-rule"></div>' +
        '<button class="aceu-x" type="button" aria-label="Close">' +
          '<svg viewBox="0 0 20 20" width="15" height="15" aria-hidden="true" focusable="false">' +
          '<path d="M3 3 L17 17 M17 3 L3 17" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>' +
        '</button>' +
        '<div class="aceu-body">' +
          '<p class="aceu-eyebrow">' + fill(S.modalEyebrow, country) + '</p>' +
          '<h2 class="aceu-title" id="aceu-title">' + fill(S.modalHeading, country) + '</h2>' +
          '<p class="aceu-text">' + fill(S.modalBody, country) + '</p>' +
          '<div class="aceu-actions">' +
            '<a class="aceu-btn aceu-btn--primary" href="' + esc(url) + '" rel="noopener">' +
              fill(S.modalPrimary, country) + '</a>' +
            '<button class="aceu-btn aceu-btn--ghost" type="button">' +
              fill(S.modalSecondary, country) + '</button>' +
          '</div>' +
          (S.modalFootnote ? '<p class="aceu-foot">' + fill(S.modalFootnote, country) + '</p>' : '') +
        '</div>' +
      '</div>';

    function close() {
      remember();
      wrap.classList.remove('is-open');
      document.documentElement.classList.remove('aceu-locked');
      setTimeout(function () { wrap.remove(); }, 220);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      document.removeEventListener('keydown', onKey);
    }

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = wrap.querySelectorAll('a[href], button');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    wrap.querySelector('.aceu-x').addEventListener('click', close);
    wrap.querySelector('.aceu-btn--ghost').addEventListener('click', close);
    wrap.querySelector('.aceu-btn--primary').addEventListener('click', remember);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    document.addEventListener('keydown', onKey);

    lastFocus = document.activeElement;
    document.body.appendChild(wrap);
    document.documentElement.classList.add('aceu-locked');
    requestAnimationFrame(function () {
      wrap.classList.add('is-open');
      var b = wrap.querySelector('.aceu-btn--primary');
      if (b) b.focus({ preventScroll: true });
    });

    return wrap;
  }

  function noticeHost() {
    var host = document.querySelector('[data-aceu-notice-slot]');
    if (host) return host;
    var form = document.querySelector('product-form, .product-form, form[action*="/cart/add"]');
    if (!form) return null;
    host = document.createElement('div');
    host.setAttribute('data-aceu-notice-slot', '');
    form.parentNode.insertBefore(host, form.nextSibling);
    return host;
  }

  function buildNotice(country, url, otherFormat) {
    var host = noticeHost();
    if (!host) return null;

    var body = otherFormat
      ? fill(S.noticeBodyOther, country, otherFormat)
      : fill(S.noticeBody, country);

    var el = document.createElement('aside');
    el.className = 'aceu-notice';
    el.innerHTML =
      '<div class="aceu-notice__mark" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" ' +
        'stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" focusable="false">' +
        '<circle cx="12" cy="12" r="9"/><path d="M3 12h18"/>' +
        '<path d="M12 3a15 15 0 0 1 0 18a15 15 0 0 1 0-18"/></svg>' +
      '</div>' +
      '<div class="aceu-notice__body">' +
        '<p class="aceu-notice__head">' + fill(S.noticeHeading, country) + '</p>' +
        '<p class="aceu-notice__text">' + body + '</p>' +
        '<a class="aceu-notice__link" href="' + esc(url) + '" rel="noopener">' +
          fill(S.noticeLink, country) +
          '<svg viewBox="0 0 16 16" width="11" height="11" aria-hidden="true" focusable="false">' +
          '<path d="M3 13 L13 3 M6 3h7v7" stroke="currentColor" stroke-width="1.7" fill="none" ' +
          'stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</a>' +
      '</div>';

    host.appendChild(el);
    return el;
  }

  // Show, hide or re-point the notice for whatever format is selected now.
  // Switching to a format Townsend does not carry removes it entirely,
  // rather than leaving a link that goes to the wrong record.
  function syncNotice(country, ctx) {
    var hit = resolveForNotice(ctx);
    var existing = document.querySelector('.aceu-notice');

    // Rebuilt rather than re-pointed, because the wording changes with the
    // format, not just the link.
    if (existing) existing.remove();
    if (!hit) return null;
    return buildNotice(country, hit.url, hit.otherFormat);
  }

  // No theme fires a variant event we can rely on across the board, so we
  // watch the hidden id input the buy form keeps current. The listeners
  // make it feel instant, the poll catches themes that swap the input out.
  function watchVariant(onChange) {
    var last = null;

    function read() {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var v = (input && input.value) ||
              new URLSearchParams(window.location.search).get('variant') || '';
      if (v !== last) { last = v; onChange(); }
    }

    read();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) {
        setTimeout(read, 0);
      }
    }, true);
    window.addEventListener('popstate', read);
    setInterval(read, 500);
  }

  /* ------------------------------------------------------------------ *
   * 8. Go
   * ------------------------------------------------------------------ */

  function run() {
    if (!S.enabled) return;
    if (window.Shopify && window.Shopify.designMode && !readOverride()) return;

    detectCountry().then(function (country) {
      if (!country) return;
      var inScope = targetCountries();
      if (!inScope[country]) return;

      document.documentElement.setAttribute('data-aceu-country', country);

      return loadMap().then(function () {
        var ctx = window.ACEU_PRODUCT || null;

        if (S.showProductNotice && ctx) {
          watchVariant(function () { syncNotice(country, ctx); });
        }

        if (S.showModal && modalAllowedHere() && !dismissed()) {
          setTimeout(function () {
            var deep = resolveForNotice(ctx);
            buildModal(country, (deep && deep.url) || TOWNSEND_MAP.home);
          }, S.delayMs || 0);
        }
      });
    });
  }

  // Exposed so the preview harness can drive it, and so you can re-open the
  // modal from the console with ACEU.open('GB') while checking copy.
  window.ACEU = {
    run: run,
    open: function (c) { buildModal(c || 'GB', TOWNSEND_MAP.home); },
    notice: function (c, u) { return buildNotice(c || 'GB', u || TOWNSEND_MAP.home); },
    reset: function () {
      try {
        localStorage.removeItem(STORE_KEY);
        localStorage.removeItem(PIN_KEY);
        sessionStorage.removeItem(GEO_KEY);
      } catch (e) {}
    },
    settings: S,
    isHomePage: isHomePage,
    modalAllowedHere: modalAllowedHere,
    groups: GROUPS,
    names: COUNTRY_NAMES,
    map: TOWNSEND_MAP,
    loadMap: loadMap,
    resolveProduct: resolveProduct,
    resolveForNotice: resolveForNotice,
    currentVariant: currentVariant,
    syncNotice: syncNotice,
    targetCountries: targetCountries
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
